// extracted by mini-css-extract-plugin
export default {"gpa__contacts_section_wrapper":"ContactSection_gpa__contacts_section_wrapper__b1SyH","gpa_dark_mode":"ContactSection_gpa_dark_mode__zS1RI"};